import { render, staticRenderFns } from "./PostSection4.vue?vue&type=template&id=5af34b88&scoped=true"
import script from "./PostSection4.vue?vue&type=script&lang=js"
export * from "./PostSection4.vue?vue&type=script&lang=js"
import style0 from "./PostSection4.vue?vue&type=style&index=0&id=5af34b88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af34b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af34b88')) {
      api.createRecord('5af34b88', component.options)
    } else {
      api.reload('5af34b88', component.options)
    }
    module.hot.accept("./PostSection4.vue?vue&type=template&id=5af34b88&scoped=true", function () {
      api.rerender('5af34b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSection4.vue"
export default component.exports